import React from "react";
import { Instagram, ExternalLink } from "lucide-react";
import { useUGC } from "../lib/hooks";

export default function UGCSection() {
  const ugc = useUGC();
  if (!ugc || ugc.length === 0) return null;

  return (
    <section className="py-12 md:py-20" data-testid="ugc-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 text-[#FF5A1F] text-[10px] md:text-xs font-bold uppercase tracking-[0.24em] md:tracking-[0.26em]">
            <Instagram className="w-4 h-4" /> As Seen on Instagram
          </div>
          <h2 className="mt-2 md:mt-3 font-display text-2xl md:text-4xl font-black leading-tight">Real people, real style</h2>
          <p className="mt-2 text-neutral-500 text-xs md:text-sm max-w-md mx-auto">
            Tag <span className="font-semibold text-neutral-900">@stealodeal</span> to be featured here.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {ugc.map((post) => (
            <a
              key={post.id}
              href={post.embed_url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-[4/5] bg-neutral-100 rounded-2xl overflow-hidden"
              data-testid={`ugc-${post.id}`}
            >
              {post.thumbnail ? (
                <img src={post.thumbnail} alt={post.title || "UGC post"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-[#FF5A1F]/20 to-neutral-900/40 flex items-center justify-center">
                  <Instagram className="w-10 h-10 text-white opacity-60" />
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                {post.author_handle && <div className="text-xs font-semibold opacity-90">@{post.author_handle.replace("@", "")}</div>}
                {post.title && <div className="text-sm font-medium line-clamp-2 mt-0.5">{post.title}</div>}
              </div>
              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                <ExternalLink className="w-3.5 h-3.5" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
